import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DevisService from '../../../../services/devis/DevisService';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import './DevisContent.css';
import DevisContentTab from './DevisContentTab';

const styles = theme => ({
    root: {
        marginLeft: '10px',
        marginRight: '10px'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    }
});

class DevisContent extends Component {

    constructor(props) {
        super(props);
        var expandedPanel = null;
        if (this.props.datas.params.expanededPanel != null) {
            expandedPanel = this.props.datas.params.expanededPanel;
        }
        this.state = {
            expanded: expandedPanel,
            customLines: 0
        };
    }

    handlePanelChange = panel => (event, expanded) => {
        var expandedPanel = expanded ? panel : false;
        this.props.datas.params["expanededPanel"] = expandedPanel;
        this.setState({
            expanded: expandedPanel,
            [this.props.categorie]: this.props.datas.content[this.props.categorie]
        });
    };

    renderWithCategorie() {
        const { classes } = this.props;
        const { expanded } = this.state;
        var service = new DevisService();
        console.log(this.props.datas);

        var products = service.getById(this.props.categorie);
        var retour = [];
        if (products != null) {
            var _this = this;
            products.forEach(function (p) {
                var valProd = _this.props.datas.params[p.categorieProduitCode];
                if (valProd != null) {
                    var max = + valProd;
                    for (var i = 0; i < max; i++) {
                        var numero = "";
                        if (max > 1) {
                            numero = i + 1;
                        }
                        retour.push(
                            <ExpansionPanel key={p.categorieProduitId} expanded={expanded === 'panel' + p.categorieProduitId} onChange={_this.handlePanelChange('panel' + p.categorieProduitId)}>
                                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography className={classes.heading}>{p.categorieProduitLibelle} {numero}</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails className='devisContentPanel'>
                                    <DevisContentTab products={p.contenu} categorie={_this.props.categorie} categorieProduitId={p.categorieProduitId} datas={_this.props.datas} />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        )
                    }
                }
            });

        }
        return retour;
    }

    render() {
        const { classes } = this.props;
        return (<div className={classes.root}>
            {this.renderWithCategorie()}
        </div>);
    }

}

DevisContent.propTypes = {
    datas: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return state
}

export default connect(mapStateToProps
)(withStyles(styles)(DevisContent));


// WEBPACK FOOTER //
// ./src/components/content/devis/content/DevisContent.js